/**
 * walleu-quantity-coverage
 * <walleu-quantity-coverage> — shows how many m² the chosen quantity covers,
 * next to the product quantity stepper. Listens to the quantity input's
 * `input`/`change` events (so +/− buttons, typing and programmatic changes
 * that dispatch `change` — e.g. the quantity-breaks tier cards — all work).
 */
(function () {
  if (window.customElements.get('walleu-quantity-coverage')) return;

  class WalleuQuantityCoverage extends HTMLElement {
    connectedCallback() {
      this.panelArea = parseFloat(this.dataset.panelArea); // cm²

      const formControl = this.closest('.form-control');
      this.quantityInput = formControl && formControl.querySelector('quantity-selector input');
      if (!this.quantityInput || !(this.panelArea > 0)) return;

      const locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'pt';
      this.areaFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });

      this.update = this.update.bind(this);
      this.quantityInput.addEventListener('input', this.update);
      this.quantityInput.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      if (!this.quantityInput) return;
      this.quantityInput.removeEventListener('input', this.update);
      this.quantityInput.removeEventListener('change', this.update);
    }

    update() {
      const quantity = parseInt(this.quantityInput.value, 10);

      if (!(quantity > 0)) {
        this.textContent = '';
        return;
      }

      const coveredM2 = (quantity * this.panelArea) / 10000; // cm² → m²
      this.textContent = (this.dataset.coversTemplate || '[area] m²').replace(
        '[area]',
        this.areaFormat.format(coveredM2)
      );
    }
  }

  customElements.define('walleu-quantity-coverage', WalleuQuantityCoverage);
})();
